export default __webpack_public_path__ + "static/pro-2ec98662f5166cf01e798a96d12ca1e2.png";